import React from 'react';
import styled from 'styled-components';
import Panel from './Panel';
import useMonitoringData from '../hooks/useMonitoring';
import { fetchRecentActivity } from '../api/monitoringApi';

const List = styled.div`max-height: 400px; overflow-y: auto;`;

const Item = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f3f4f6;
  &:last-child { border-bottom: none; }
`;

const Dot = styled.div`
  width: 8px; height: 8px; border-radius: 50%; margin-top: 6px; flex-shrink: 0;
  background: ${p => {
    switch(p.$type) {
      case 'signup': return '#3b82f6';
      case 'site_created': return '#8b5cf6';
      case 'subscribe': return '#10b981';
      case 'payment': return '#f59e0b';
      default: return '#9ca3af';
    }
  }};
`;

const Time = styled.span`font-size: 12px; color: #9ca3af; min-width: 44px;`;
const Tag = styled.span`
  font-size: 11px; padding: 2px 6px; border-radius: 4px; font-weight: 600;
  background: ${p => {
    switch(p.$type) {
      case 'signup': return '#dbeafe';
      case 'site_created': return '#ede9fe';
      case 'subscribe': return '#d1fae5';
      case 'payment': return '#fef3c7';
      default: return '#f3f4f6';
    }
  }};
  color: ${p => {
    switch(p.$type) {
      case 'signup': return '#1d4ed8';
      case 'site_created': return '#6d28d9';
      case 'subscribe': return '#047857';
      case 'payment': return '#b45309';
      default: return '#6b7280';
    }
  }};
`;

const Desc = styled.span`font-size: 13px; color: #374151;`;

const LABELS = { signup: '가입', site_created: '사이트', subscribe: '구독', payment: '결제' };

function formatTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
}

function description(item) {
  const { event_type, client_name, client_email, detail } = item;
  const name = client_name || client_email || '';
  switch (event_type) {
    case 'signup':
      return `${name} ${detail.signup_type} 회원가입`;
    case 'site_created':
      return `${name} ${detail.domain} 사이트 등록`;
    case 'subscribe':
      return `${name} ${detail.site_name || ''} ${detail.plan_type} ${detail.is_paid ? '유료' : '무료'}`;
    case 'payment':
      return `${name} ₩${Number(detail.amount || 0).toLocaleString()} 결제`;
    default:
      return name;
  }
}

export default function RecentActivityPanel({ refreshKey }) {
  const { data, isLoading, error } = useMonitoringData(() => fetchRecentActivity(30), [refreshKey]);

  return (
    <Panel title="최근 활동 타임라인" isLoading={isLoading} error={error}>
      <List>
        {data?.items?.map((item, i) => (
          <Item key={i}>
            <Dot $type={item.event_type} />
            <Time>{formatTime(item.timestamp)}</Time>
            <Tag $type={item.event_type}>{LABELS[item.event_type]}</Tag>
            <Desc>{description(item)}</Desc>
          </Item>
        ))}
        {data?.items?.length === 0 && <div style={{ color: '#9ca3af', textAlign: 'center', padding: 24 }}>최근 활동이 없습니다</div>}
      </List>
    </Panel>
  );
}
